@if(!otherUser) {
<div class="findJobplanCard">
  <div class="findbtndiv">
    <button (click)="findJobplanPopup()" class="findbtn">
      Find and Replace Job Plan Number
    </button>
    <button (click)="undoJobPlan()" *ngIf="undoList.length > 0" class="undobtn">
      Undo
    </button>
  </div>
</div>
}

<ng-template #template>
  <ul>
    <li *ngFor="let list of view_tooltipList">
      <span>{{ list }}</span>
    </li>
  </ul>
</ng-template>
<!-- Labour -->
<div
  kendoTooltip
  showOn="none"
  [tooltipTemplate]="template"
  filter=".k-grid td"
  (mouseover)="showTooltip($event)"
>
  <ng-template #addtocr>
    <span>row not yet added to CR</span>
  </ng-template>
  <div class="margin-15">
    <kendo-expansionpanel
      title="Labour"
      [expanded]="true"
      (click)="expandCollapseContent()"
    >
      <ng-template kendoExpansionPanelTitleDirective>
        <div class="header-content">
          <span class="expansion-title">Labour</span>
          <span class="expansion-subtitle">{{ jpLabourMessage }}</span>
        </div>
      </ng-template>
      <div class="expBtnList">
        <div>
          <kendo-dropdownlist
            [disabled]="otherUser"
            [(ngModel)]="bulkActionLabourValue"
            defaultItem="No change"
            [data]="dropDownListLabour"
            class="changeDropdownList"
          >
          </kendo-dropdownlist>

          <button
            [disabled]="labourSelectedIds.size == 0 || otherUser"
            class="chDisabled button-secondary"
            (click)="bulkActionLabourNew()"
          >
            Apply action to Selection
          </button>
          <button
            (click)="undoLabourAction()"
            *ngIf="labourActionApplied"
            class="undobtn"
          >
            Undo
          </button>
        </div>
        <div>
          <button
            [disabled]="otherUser"
            class="button-primary"
            [ngClass]="otherUser ? 'btn-disabled' : ''"
            (click)="clearAll()"
          >
            Clear All Labour
          </button>
          <button
            class="button-secondary"
            [disabled]="!labourSelectedIds.size || otherUser"
            (click)="clearSelected()"
            [ngClass]="
              !labourSelectedIds.size || otherUser ? 'btn-disabled' : ''
            "
          >
            Clear Selected
          </button>
          <button
            class="button-secondary_Export"
            (click)="clickExport($event, 'labour')"
          >
            Export
          </button>
          <button
            [disabled]="otherUser"
            [ngClass]="otherUser ? 'btn-disabled' : ''"
            class="button-secondary_Import"
            (click)="openActionPopup('labour', 'labour')"
          >
            Import
          </button>
        </div>
      </div>
      <!-- [rowClass]="getClassByColor" -->
      <div id="nonStyleGrid">
        <kendo-grid
          [rowClass]="getClassByColor"
          [data]="labourViewData"      
         class='buildGrid'
          [selectable]="{ enabled: true, checkboxOnly: true }"
          (selectionChange)="OnSelectionChangeEventGrid($event, 'labour')"
        >
          <kendo-grid-checkbox-column
            [width]="45"
            [headerClass]="{ 'text-center': true }"
            [class]="{ 'text-center': true }"
            [resizable]="false"
            [columnMenu]="true"
            id="my-grid"
            [columnMenu]="false"
            [showSelectAll]="true"
            class="customgrid"
          >
          </kendo-grid-checkbox-column>

          <kendo-grid-column field="mwo" title="" [width]="85">
            <ng-template kendoGridCellTemplate let-dataItem>
              <span
                *ngIf="
                  ['Add', 'Delete', 'No change', 'Change'].includes(
                    dataItem.acdAction
                  )
                "
                (click)="
                  !otherUser ? cloneLabourItem(dataItem.changeItemId) : null
                "
              >
                <fa-icon
                  [icon]="iconPacks.FASQUAREPLUS"
                  class="bluePrimary pmBtnSize plusIcon"
                  [ngClass]="{
                    showCursor: !otherUser,
                    iconDisabled: otherUser
                  }"
                ></fa-icon
              ></span>
              <span
                *ngIf="
                  ['Add', 'No change', 'Change'].includes(dataItem.acdAction)
                "
                (click)="
                  !otherUser
                    ? removeLabourItem(dataItem.changeItemId, dataItem)
                    : null
                "
              >
                <fa-icon
                  [icon]="iconPacks.FAMINUSSQUARE"
                  class="bluePrimary pmBtnSize ml-5 plusIcon"
                  [ngClass]="{
                    showCursor: !otherUser,
                    iconDisabled: otherUser
                  }"
                ></fa-icon
              ></span>
              <span
                *ngIf="['Delete', 'Change'].includes(dataItem.acdAction)"
                (click)="
                  !otherUser ? undoLabourById(dataItem.changeItemId) : null
                "
              >
                <fa-icon
                  [icon]="iconPacks.FACIRCLE"
                  class="bluePrimary ml-5 pmBtnSize searchIcon"
                  [ngClass]="{
                    showCursor: !otherUser,
                    iconDisabled: otherUser
                  }"
                ></fa-icon>
              </span>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column field="acdAction" title="ACD Action" [width]="100">
            <ng-template kendoGridCellTemplate let-dataItem>
              <span>
                {{ dataItem.acdAction }}
              </span>
            </ng-template>
          </kendo-grid-column>

          <!-- not in object -->
          <kendo-grid-column title="" [width]="50">
            <ng-template kendoGridCellTemplate let-dataItem>
              <fa-icon
                [icon]="iconPacks.FASTAR"
                class="plusIcon plusiconHover"
                *ngIf="!dataItem.isAddedToCR"
              ></fa-icon>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column
            field="view_equipTagNumber"
            title="Equip Tag Number"
            [width]="200"
          >
            <ng-template
              kendoGridCellTemplate
              let-dataItem
              let-rowIndex="rowIndex"
            >
              <!-- <span [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }">
              {{ dataItem.view_equipTagNumber }}
            </span> -->
              <span
                class="headerTagNumberSpan"
                id="{{ 'equipTagNumberLabour_' + rowIndex }}"
                [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }"
                [innerHTML]="dataItem.view_equipTagNumber"
              >
              </span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            field="view_mwoNumber"
            title="MWO Number"
            [width]="200"
          >
            <ng-template
              kendoGridCellTemplate
              let-dataItem
              let-rowIndex="rowIndex"
            >
              <!-- <span [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }">
              {{ dataItem.view_mwoNumber }}
            </span> -->
              <span
                class="headerTagNumberSpan"
                id="{{ 'mwoNumberLabour_' + rowIndex }}"
                [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }"
                [innerHTML]="dataItem.view_mwoNumber"
              >
              </span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            field="view_mwoProblemDescription"
            title="MWO Problem Description"
            [width]="250"
          >
            <ng-template
              kendoGridCellTemplate
              let-dataItem
              let-rowIndex="rowIndex"
            >
              <!-- <span [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }">
              {{ dataItem.view_mwoProblemDescription }}
            </span> -->
              <span
                class="headerTagNumberSpan"
                id="{{ 'mwoProblemDescriptionLabour_' + rowIndex }}"
                [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }"
                [innerHTML]="dataItem.view_mwoProblemDescription"
              >
              </span>
            </ng-template>
          </kendo-grid-column>
          <!-- Job Plan Number -->
          <kendo-grid-column
            field="jobPlanNumber"
            title="Job plan Number"
            [width]="380"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              @if(dataItem.acdAction !== 'Add') {

              <span
                [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }"
              >
                {{ dataItem.jobPlanNumber }}
              </span>
              } @else {

              <kendo-textbox
                [disabled]="otherUser"
                style="width: 80%"
                #jobPlanSearchTextBox
                [maxlength]="50"
                (valueChange)="onValueChange(dataItem, 'jobPlanNumber', $event)"
                id="{{ dataItem.changeItemId + '_jobPlanNumber' }}"
                [(ngModel)]="dataItem.jobPlanNumber"
                [ngClass]="{
                  backgroundChange:
                    dataItem.acdAction === 'Add' ||
                    (dataItem.acdAction == 'Change' &&
                      dataItem.fieldChangedList?.includes('jobPlanNumber')),
                  'field-mandatory':
                    dataItem.errorList?.includes('jobPlanNumber')
                }"
              >
              </kendo-textbox>
              <span *ngIf="!otherUser" #jobPlanSearch>
                <fa-icon
                  [icon]="iconPacks.FASEARCH"
                  [style]="'margin-left: 5px;'"
                  class="bluePrimary searchIcon showCursor"
                  (click)="openActionPopup('jobPlanNumber', dataItem)"
                ></fa-icon>
              </span>
              }
            </ng-template>
          </kendo-grid-column>
          <!-- jobPlanDescription -->
          <kendo-grid-column
            field="jobPlanDescription"
            title="Job Plan Description"
            [width]="300"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              @if(dataItem.acdAction == 'Delete') {

              <span
                [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }"
              >
                {{ dataItem.jobPlanDescription }}
              </span>
              } @else {

              <kendo-textbox
                [disabled]="otherUser"
                #jobPlanSearchTextBox
                [maxlength]="50"
                (valueChange)="
                  onValueChange(dataItem, 'jobPlanDescription', $event)
                "
                id="{{ dataItem.changeItemId + '_jobPlanDescription' }}"
                [(ngModel)]="dataItem.jobPlanDescription"
                [ngClass]="{
                  backgroundChange:
                    dataItem.acdAction === 'Add' ||
                    (dataItem.acdAction == 'Change' &&
                      dataItem.fieldChangedList?.includes(
                        'jobPlanDescription'
                      )),
                  'field-mandatory':
                    dataItem.errorList?.includes('jobPlanDescription')
                }"
              >
              </kendo-textbox>
              }
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            field="branchPlant"
            title="Branch Plant"
            [width]="100"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              <span
                [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }"
              >
                {{ dataItem.branchPlant }}
              </span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            field="performanceStandard"
            title="Performance Standard"
            [width]="110"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              <span
                [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }"
              >
                {{ dataItem.performanceStandard }}
              </span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="craft" title="Craft" [width]="200">
            <ng-template kendoGridCellTemplate let-dataItem>
              @if(dataItem.acdAction == 'Delete'){
              <span
                [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }"
              >
                {{ dataItem.craft }}
              </span>
              } @else {
              <kendo-textbox
                [disabled]="otherUser"
                (valueChange)="onValueChange(dataItem, 'craft', $event)"
                [maxlength]="20"
                placeholder="Please insert code only"
                style="width: 80%"
                id="{{ dataItem.changeItemId + '_craft' }}"
                [(ngModel)]="dataItem.craft"
                [ngClass]="{
                  backgroundChange:
                    dataItem.acdAction === 'Add' ||
                    (dataItem.acdAction == 'Change' &&
                      dataItem.fieldChangedList?.includes('craft')),
                  'field-mandatory': dataItem.errorList?.includes('craft')
                }"
              >
              </kendo-textbox>
              <span #taskId *ngIf="!otherUser">
                <fa-icon
                  [icon]="iconPacks.FASEARCH"
                  [style]="'margin-left: 5px;'"
                  class="bluePrimary searchIcon showCursor"
                  (click)="openActionPopup('craft', dataItem)"
                ></fa-icon>
              </span>
              }
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="opsSeq" title="Ops Seq" [width]="100">
            <ng-template kendoGridCellTemplate let-dataItem>
              @if(dataItem.acdAction == 'Add' || dataItem.isNewJobPlan == true)
              { @if (dataItem.acdAction == 'Delete') {
              <span
                [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }"
              >
                {{ dataItem.opsSeq }}
              </span>
              }@else {
              <kendo-numerictextbox
                [spinners]="false"
                [disabled]="otherUser"
                [step]="1"
                (valueChange)="onValueChange(dataItem, 'opsSeq', $event)"
                [format]="customFormat(dataItem.opsSeq)"
                id="{{ dataItem.changeItemId + '_opsSeq' }}"
                [(ngModel)]="dataItem.opsSeq"
                [ngClass]="{
                  backgroundChange:
                    dataItem.acdAction === 'Add' ||
                    (dataItem.acdAction == 'Change' &&
                      dataItem.fieldChangedList?.includes('opsSeq')),
                  'field-mandatory': dataItem.errorList?.includes('opsSeq')
                }"
              >
              </kendo-numerictextbox
              >} }@else {
              <span
                [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }"
              >
                {{ dataItem.opsSeq }}
              </span>

              }
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="norms" title="Norms" [width]="80">
            <ng-template kendoGridCellTemplate let-dataItem>
              @if(dataItem.acdAction == 'Delete') {

              <span
                [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }"
              >
                {{ dataItem.norms }}
              </span>
              } @else {

              <kendo-dropdownlist
                [disabled]="otherUser"
                [(ngModel)]="dataItem.norms"
                defaultItem=""
                [data]="normsList"
                class="changeDropdownNorms bg-white"
                (valueChange)="onValueChange(dataItem, 'norms', $event)"
                [ngClass]="{
                  backgroundChange:
                    dataItem.acdAction === 'Add' ||
                    (dataItem.acdAction == 'Change' &&
                      dataItem.fieldChangedList?.includes('norms')),
                  'field-mandatory': dataItem.errorList?.includes('norms')
                }"
              >
              </kendo-dropdownlist>
              }
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            field="description"
            title="Description"
            [width]="300"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              @if(dataItem.acdAction == 'Delete') {

              <span
                [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }"
              >
                {{ dataItem.description }}
              </span>
              } @else {

              <kendo-textbox
                [disabled]="otherUser"
                (valueChange)="onValueChange(dataItem, 'description', $event)"
                [maxlength]="80"
                id="{{ dataItem.changeItemId + '_description' }}"
                [(ngModel)]="dataItem.description"
                [ngClass]="{
                  backgroundChange:
                    dataItem.acdAction === 'Add' ||
                    dataItem.fieldChangedList?.includes('description'),
                  'field-mandatory': dataItem.errorList?.includes('description')
                }"
              >
              </kendo-textbox>
              }
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="duration" title="Duration" [width]="100">
            <ng-template kendoGridCellTemplate let-dataItem>
              @if(dataItem.acdAction == 'Delete') {

              <span
                [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }"
              >
                {{ dataItem.duration }}
              </span>
              } @else {

              <kendo-numerictextbox
                [disabled]="otherUser"
                [spinners]="false"
                [autoCorrect]="true"
                [step]="1"
                [format]="customFormat(dataItem.duration)"
                (valueChange)="onValueChange(dataItem, 'duration', $event)"
                format="#."
                id="{{ dataItem.changeItemId + '_duration' }}"
                [(ngModel)]="dataItem.duration"
                [ngClass]="{
                  backgroundChange:
                    dataItem.acdAction === 'Add' ||
                    (dataItem.acdAction == 'Change' &&
                      dataItem.fieldChangedList?.includes('duration')),
                  'field-mandatory': dataItem.errorList?.includes('duration')
                }"
              >
              </kendo-numerictextbox>
              }
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="crewSize" title="Crew Size" [width]="100">
            <ng-template kendoGridCellTemplate let-dataItem>
              @if(dataItem.acdAction == 'Delete') {

              <span
                [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }"
              >
                {{ dataItem.crewSize }}
              </span>
              } @else {

              <kendo-numerictextbox
                [disabled]="otherUser"
                [autoCorrect]="true"
                [step]="1"
                (valueChange)="onValueChange(dataItem, 'crewSize', $event)"
                format="#"
                id="{{ dataItem.changeItemId + '_crewSize' }}"
                [(ngModel)]="dataItem.crewSize"
                [ngClass]="{
                  backgroundChange:
                    dataItem.acdAction === 'Add' ||
                    (dataItem.acdAction == 'Change' &&
                      dataItem.fieldChangedList?.includes('crewSize')),
                  'field-mandatory': dataItem.errorList?.includes('crewSize')
                }"
              >
              </kendo-numerictextbox>
              }
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="icyn" title="IC Y_N" [width]="100">
            <ng-template kendoGridCellTemplate let-dataItem>
              @if(dataItem.acdAction == 'Delete') {
              <span
                [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }"
              >
                {{ dataItem.icyn }}
              </span>
              } @else {

              <kendo-dropdownlist
                [disabled]="otherUser"
                [(ngModel)]="dataItem.icyn"
                defaultItem=""
                [data]="icynList"
                class="changeDropdown bg-white"
                (valueChange)="onValueChange(dataItem, 'icyn', $event)"
                [ngClass]="{
                  backgroundChange:
                    dataItem.acdAction === 'Add' ||
                    (dataItem.acdAction == 'Change' &&
                      dataItem.fieldChangedList?.includes('icyn')),
                  'field-mandatory': dataItem.errorList?.includes('icyn')
                }"
              >
              </kendo-dropdownlist>
              }
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            field="percentageOverlap"
            title="% Overlap"
            [width]="100"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              @if(dataItem.acdAction == 'Delete') {

              <span
                [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }"
              >
                {{ dataItem.percentageOverlap }}
              </span>
              } @else {

              <kendo-numerictextbox
                [spinners]="false"
                [disabled]="otherUser"
                [autoCorrect]="true"
                [step]="1"
                [maxlength]="5"
                (valueChange)="
                  onValueChange(dataItem, 'percentageOverlap', $event)
                "
                format="#"
                id="{{ dataItem.changeItemId + '_PercentageOverlap' }}"
                [(ngModel)]="dataItem.percentageOverlap"
                [ngClass]="{
                  backgroundChange:
                    dataItem.acdAction === 'Add' ||
                    (dataItem.acdAction == 'Change' &&
                      dataItem.fieldChangedList?.includes('percentageOverlap')),
                  'field-mandatory':
                    dataItem.errorList?.includes('percentageOverlap')
                }"
              >
              </kendo-numerictextbox>
              }
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="tccid" title="TCC ID" [width]="100">
            <ng-template kendoGridCellTemplate let-dataItem>
              @if(dataItem.acdAction == 'Delete') {

              <span
                [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }"
              >
                {{ dataItem.tccid }}
              </span>
              } @else {

              <kendo-textbox
                [disabled]="otherUser"
                (valueChange)="onValueChange(dataItem, 'tccid', $event)"
                [maxlength]="3"
                style="width: 80%"
                placeholder="Task ID only"
                id="{{ dataItem.changeItemId + '_tccid' }}"
                [(ngModel)]="dataItem.tccid"
                [ngClass]="{
                  backgroundChange:
                    dataItem.acdAction === 'Add' ||
                    (dataItem.acdAction == 'Change' &&
                      dataItem.fieldChangedList?.includes('tccid')),
                  'field-mandatory': dataItem.errorList?.includes('tccid')
                }"
              >
              </kendo-textbox>
              <span #taskId *ngIf="!otherUser">
                <fa-icon
                  [icon]="iconPacks.FASEARCH"
                  [style]="'margin-left: 5px;'"
                  class="bluePrimary searchIcon showCursor"
                  (click)="openActionPopup('tccid', dataItem)"
                ></fa-icon>
              </span>
              }
            </ng-template>
          </kendo-grid-column>
          <!-- inspectionID -->
          <kendo-grid-column
            field="messageNumber"
            title="Inspection ID"
            [width]="200"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              @if(dataItem.acdAction == 'Delete') {

              <span
                [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }"
              >
                {{ dataItem.messageNumber }}
              </span>
              } @else {
              <kendo-textbox
                [disabled]="otherUser"
                (valueChange)="onValueChange(dataItem, 'messageNumber', $event)"
                [maxlength]="100"
                id="{{ dataItem.changeItemId + '_messageNumber' }}"
                [(ngModel)]="dataItem.messageNumber"
                [ngClass]="{
                  backgroundChange:
                    dataItem.acdAction === 'Add' ||
                    (dataItem.acdAction == 'Change' &&
                      dataItem.fieldChangedList?.includes('messageNumber')),
                  'field-mandatory':
                    dataItem.errorList?.includes('messageNumber')
                }"
              >
              </kendo-textbox>
              }
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            field="equipmentNumber"
            title="Equipment Number"
            [width]="200"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              @if(dataItem.acdAction == 'Delete') {
              <span
                [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }"
              >
                {{ dataItem.equipmentNumber }}
              </span>
              } @else {
              <kendo-textbox
                [disabled]="otherUser"
                (valueChange)="
                  onValueChange(dataItem, 'equipmentNumber', $event)
                "
                [maxlength]="50"
                id="{{ dataItem.changeItemId + '_EquipmentNumber' }}"
                [(ngModel)]="dataItem.equipmentNumber"
                [ngClass]="{
                  backgroundChange:
                    dataItem.acdAction === 'Add' ||
                    (dataItem.acdAction == 'Change' &&
                      dataItem.fieldChangedList?.includes('equipmentNumber')),
                  'field-mandatory':
                    dataItem.errorList?.includes('equipmentNumber')
                }"
              >
              </kendo-textbox>
              }
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            field="jobPackNo"
            title="Job Pack No"
            [width]="200"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              @if(dataItem.acdAction == 'Delete') {
              <span
                [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }"
              >
                {{ dataItem.jobPackNo }}
              </span>

              } @else {

              <kendo-textbox
                [disabled]="otherUser"
                (valueChange)="onValueChange(dataItem, 'jobPackNo', $event)"
                [maxlength]="15"
                id="{{ dataItem.changeItemId + '_jobPackNo' }}"
                [(ngModel)]="dataItem.jobPackNo"
                [ngClass]="{
                  backgroundChange:
                    dataItem.acdAction === 'Add' ||
                    (dataItem.acdAction == 'Change' &&
                      dataItem.fieldChangedList?.includes('jobPackNo')),
                  'field-mandatory': dataItem.errorList?.includes('jobPackNo')
                }"
              >
              </kendo-textbox>
              }
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="fileName" title="File Name" [width]="300">
            <ng-template kendoGridCellTemplate let-dataItem>
              @if(dataItem.acdAction == 'Delete') {

              <span
                [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }"
              >
                {{ dataItem.fileName }}
              </span>

              } @else {

              <kendo-textbox
                [disabled]="otherUser"
                (valueChange)="onValueChange(dataItem, 'fileName', $event)"
                [maxlength]="80"
                id="{{ dataItem.changeItemId + '_fileName' }}"
                [(ngModel)]="dataItem.fileName"
                [ngClass]="{
                  backgroundChange:
                    dataItem.acdAction === 'Add' ||
                    (dataItem.acdAction == 'Change' &&
                      dataItem.fieldChangedList?.includes('fileName')),
                  'field-mandatory': dataItem.errorList?.includes('fileName')
                }"
              >
              </kendo-textbox>
              }
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="url" title="URL" [width]="500">
            <ng-template kendoGridCellTemplate let-dataItem>
              @if(dataItem.acdAction == 'Delete') {

              <span
                [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }"
                [title]="dataItem.url"
              >
                {{ dataItem.url }}
              </span>
              } @else {

              <kendo-textbox
                [disabled]="otherUser"
                (valueChange)="onValueChange(dataItem, 'url', $event)"
                [maxlength]="254"
                id="{{ dataItem.changeItemId + '_url' }}"
                [(ngModel)]="dataItem.url"
                [title]="dataItem.url"
                [ngClass]="{
                  backgroundChange:
                    dataItem.acdAction === 'Add' ||
                    (dataItem.acdAction == 'Change' &&
                      dataItem.fieldChangedList?.includes('url')),
                  'field-mandatory': dataItem.errorList?.includes('url')
                }"
              >
              </kendo-textbox>
              }
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            field="fileDescription"
            title="File Description"
            [width]="500"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              @if(dataItem.acdAction == 'Delete') {

              <span
                [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }"
                    [title]="dataItem.fileDescription"
              >
                {{ dataItem.fileDescription }}
              </span>
              } @else {

              <kendo-textbox
                [disabled]="otherUser"
                (valueChange)="
                  onValueChange(dataItem, 'fileDescription', $event)
                "
                id="{{ dataItem.changeItemId + '_fileDescription' }}"
                [maxlength]="148"
                [(ngModel)]="dataItem.fileDescription"
                [title]="dataItem.fileDescription"
                [ngClass]="{
                  backgroundChange:
                    dataItem.acdAction === 'Add' ||
                    (dataItem.acdAction == 'Change' &&
                      dataItem.fieldChangedList?.includes('fileDescription')),
                  'field-mandatory':
                    dataItem.errorList?.includes('fileDescription')
                }"
              >
              </kendo-textbox>
              }
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            field="textAttachments"
            title="Text Attachments"
            [width]="300"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              @if(dataItem.acdAction == 'Delete') {

              <span
                [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }"
                [title]="dataItem.textAttachments"
              >
                {{ dataItem.textAttachments }}
              </span>
              } @else {

              <kendo-textbox
                [disabled]="otherUser"
                (valueChange)="
                  onValueChange(dataItem, 'textAttachments', $event)
                "
                [maxlength]="1500"
                id="{{ dataItem.changeItemId + '_textAttachments' }}"
                [(ngModel)]="dataItem.textAttachments"
                [title]="dataItem.textAttachments"
                [ngClass]="{
                  backgroundChange:
                    dataItem.acdAction === 'Add' ||
                    (dataItem.acdAction == 'Change' &&
                      dataItem.fieldChangedList?.includes('textAttachments')),
                  'field-mandatory':
                    dataItem.errorList?.includes('textAttachments')
                }"
              >
              </kendo-textbox>
              }
            </ng-template>
          </kendo-grid-column>
          <ng-template kendoGridNoRecordsTemplate>
            <div class="norecordsmwobuild">No items to show...</div>
          </ng-template>
        </kendo-grid>
      </div>
      <app-grid-mwo-error
        *ngIf="mwoErrorTextList.length > 0"
        [setGridData]="mwoErrorTextList"
      ></app-grid-mwo-error>

      <span class="totalCount">{{ labourViewData.length }} Labour Steps</span>
    </kendo-expansionpanel>
  </div>
</div>
<!-- Parts -->
<div
  kendoTooltip
  showOn="none"
  [tooltipTemplate]="template"
  filter=".k-grid td"
  (mouseover)="showTooltipParts($event)"
>
  <div class="margin-15">
    <kendo-expansionpanel
      title="Parts"
      class="expansion"
      [expanded]="true"
      (click)="expandCollapseContent()"
    >
      <ng-template kendoExpansionPanelTitleDirective>
        <div class="header-content">
          <span class="expansion-title">Parts</span>
          <span class="expansion-subtitle">{{ jpPartsMessage }}</span>
        </div>
      </ng-template>
      <div class="expBtnList">
        <div>
          <kendo-dropdownlist
            [disabled]="otherUser"
            [(ngModel)]="bulkActionPartValue"
            defaultItem="No change"
            [data]="dropDownListParts"
            class="changeDropdownList"
          >
          </kendo-dropdownlist>
          <button
            [disabled]="partsSelectedIds.size == 0 || otherUser"
            class="chDisabled button-secondary"
            (click)="bulkActionPartsNew()"
          >
            Apply action to Selection
          </button>
          <!-- <button (click)="undoPartsAction()" *ngIf="partActionApplied" class="undobtn">
          Undo
        </button> -->
        </div>
        <div>
          <button
            [disabled]="otherUser && labourSelectedIds.size == 0"
            [ngClass]="
              otherUser && labourSelectedIds.size == 0 ? 'btn-disabled' : ''
            "
            class="button-secondary_Export"
            (click)="addPartRow()"
          >
            Add Row
          </button>
          <button
            class="button-secondary_Import"
            (click)="clickExport($event, 'parts')"
          >
            Export
          </button>
          <button
            [disabled]="otherUser"
            [ngClass]="otherUser ? 'btn-disabled' : ''"
            class="button-secondary_Import"
            (click)="openActionPopup('parts', 'parts')"
          >
            Import
          </button>
        </div>
      </div>
      <div id="nonStyleGrid">
        <kendo-grid
          [data]="filterPartsViewData"          
         class='buildGrid'
          [selectable]="{ enabled: true, checkboxOnly: true }"
          (selectionChange)="OnSelectionChangeEventGrid($event, 'parts')"
        >
          <kendo-grid-checkbox-column
            [width]="45"
            [headerClass]="{ 'text-center': true }"
            [class]="{ 'text-center': true }"
            [resizable]="false"
            [columnMenu]="true"
            id="my-grid"
            [columnMenu]="false"
            [showSelectAll]="true"
            class="customgrid"
          >
          </kendo-grid-checkbox-column>

          <kendo-grid-column field="mwo" title="" [width]="85">
            <ng-template kendoGridCellTemplate let-dataItem>
              <span
                *ngIf="
                  ['Add', 'Delete', 'No change', 'Change'].includes(
                    dataItem.acdAction
                  )
                "
                (click)="!otherUser && clonePartItem(dataItem.changeItemId)"
              >
                <fa-icon
                  [icon]="iconPacks.FASQUAREPLUS"
                  class="bluePrimary pmBtnSize plusIcon"
                  [ngClass]="{
                    showCursor: !otherUser,
                    iconDisabled: otherUser
                  }"
                ></fa-icon
              ></span>
              <span
                *ngIf="
                  ['Add', 'No change', 'Change'].includes(dataItem.acdAction)
                "
                class="showCursor"
                (click)="!otherUser && removePartItem(dataItem.changeItemId)"
              >
                <fa-icon
                  [icon]="iconPacks.FAMINUSSQUARE"
                  class="bluePrimary pmBtnSize ml-5 plusIcon"
                  [ngClass]="{
                    showCursor: !otherUser,
                    iconDisabled: otherUser
                  }"
                ></fa-icon
              ></span>
              <span
                *ngIf="['Delete', 'Change'].includes(dataItem.acdAction)"
                (click)="!otherUser && undoPartById(dataItem.changeItemId)"
              >
                <fa-icon
                  [icon]="iconPacks.FACIRCLE"
                  class="bluePrimary pmBtnSize ml-5 searchIcon"
                  [ngClass]="{
                    showCursor: !otherUser,
                    iconDisabled: otherUser
                  }"
                ></fa-icon>
              </span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            field="acdAction"
            title="ACD Action"
            [width]="100"
          ></kendo-grid-column>
          <kendo-grid-column title="" [width]="50">
            <ng-template kendoGridCellTemplate let-dataItem>
              <fa-icon
                [icon]="iconPacks.FASTAR"
                class="plusIcon plusiconHover"
                *ngIf="!dataItem.isAddedToCR"
              ></fa-icon>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            field="view_equipTagNumber"
            title="Equip Tag Number"
            [width]="200"
          >
            <ng-template
              kendoGridCellTemplate
              let-dataItem
              let-rowIndex="rowIndex"
            >
              <!-- <span [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }">
              {{ dataItem.view_equipTagNumber }}
            </span> -->
              <span
                kendoTooltip
                class="headerTagNumberSpan"
                id="{{ 'equipTagNumberParts_' + rowIndex }}"
                [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }"
                [innerHTML]="dataItem.view_equipTagNumber"
              >
              </span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            field="view_mwoNumber"
            title="MWO Number"
            [width]="200"
          >
            <ng-template
              kendoGridCellTemplate
              let-dataItem
              let-rowIndex="rowIndex"
            >
              <!-- <span [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }">
              {{ dataItem.view_mwoNumber }}
            </span> -->

              <span
                kendoTooltip
                class="headerTagNumberSpan"
                id="{{ 'mwoNumberParts_' + rowIndex }}"
                [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }"
                [innerHTML]="dataItem.view_mwoNumber"
              ></span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            field="view_mwoProblemDescription"
            title="MWO Problem Description"
            [width]="250"
          >
            <ng-template
              kendoGridCellTemplate
              let-dataItem
              let-rowIndex="rowIndex"
            >
              <!-- <span [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }">
              {{ dataItem.view_mwoProblemDescription }}
            </span>             -->
              <span
                kendoTooltip
                class="headerTagNumberSpan"
                id="{{ 'mwoProblemDescriptionParts_' + rowIndex }}"
                [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }"
                [innerHTML]="dataItem.view_mwoProblemDescription"
              ></span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            field="jobPlanNumber"
            title="Job Plan Number"
            [width]="200"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              <span
                [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }"
              >
                {{ dataItem.jobPlanNumber }}
              </span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            field="branchPlant"
            title="Branch Plant"
            [width]="200"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              <!-- <span [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }" *ngIf="dataItem.acdAction == 'Delete'"> -->
              <span
                [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }"
              >
                {{ dataItem.branchPlant }}
              </span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="item" title="Item" [width]="150">
            <ng-template kendoGridCellTemplate let-dataItem>
              @if(dataItem.acdAction == 'Delete') {
              <span
                [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }"
                *ngIf="dataItem.acdAction == 'Delete'"
              >
                {{ dataItem.item }}
              </span>
              } @else if ( dataItem.item == 0 && (dataItem.acdAction=='No
              Change' || dataItem.acdAction == 'No change')) {
              <span>{{ dataItem.item }}</span>
              } @else {

              <kendo-numerictextbox
                [disabled]="otherUser"
                [autoCorrect]="true"
                format="#"
                [step]="1"
                (valueChange)="onPartValueChange(dataItem, 'item', $event)"
                [maxlength]="20"
                style="width: 80%"
                placeholder="Insert code only"
                id="{{ dataItem.changeItemId + '_item' }}"
                [(ngModel)]="dataItem.item"
                (keydown.enter)="onEnterItemPressed(dataItem)"
                (blur)="onEnterItemPressed(dataItem)"
                [ngClass]="{
                  backgroundChange:
                    dataItem.acdAction === 'Add' ||
                    dataItem.fieldChangedList?.includes('item'),
                  'field-mandatory': dataItem.errorList?.includes('item')
                }"
              >
              </kendo-numerictextbox>
              <span #taskId *ngIf="!otherUser">
                <fa-icon
                  [icon]="iconPacks.FASEARCH"
                  [style]="'margin-left: 5px;'"
                  class="bluePrimary searchIcon showCursor"
                  (click)="openActionPopup('item', dataItem)"
                ></fa-icon>
              </span>
              }
            </ng-template>

            <!-- <ng-template kendoGridCellTemplate let-dataItem> 
                    <span [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }">
                      {{ dataItem.item }}
                    </span>
                 </ng-template> -->
          </kendo-grid-column>
          <!--  -->
          <kendo-grid-column field="quantity" title="Quantity" [width]="100">
            <ng-template kendoGridCellTemplate let-dataItem>
              @if(dataItem.acdAction == 'Delete') {
              <span
                [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }"
              >
                {{ dataItem.quantity }}
              </span>
              } @else if( dataItem.quantity == 0 && (dataItem.acdAction=='No
              Change' || dataItem.acdAction == 'No change')) {
              <span>{{ dataItem.quantity }}</span>
              } @else {

              <kendo-numerictextbox
                [disabled]="otherUser"
                [autoCorrect]="true"
                [step]="1"
                [value]="dataItem.quantity"
                (valueChange)="onPartValueChange(dataItem, 'quantity', $event)"
                format="#"
                id="{{ dataItem.changeItemId + '_quantity' }}"
                [(ngModel)]="dataItem.quantity"
                [ngClass]="{
                  backgroundChange:
                    dataItem.acdAction === 'Add' ||
                    dataItem.fieldChangedList?.includes('quantity'),
                  'field-mandatory': dataItem.errorList?.includes('quantity')
                }"
              >
              </kendo-numerictextbox>
              }
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            field="compBranchPlant"
            title="Comp Branch/Plant"
            [width]="200"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              <kendo-textbox
                [disabled]="true"
                [value]="dataItem.compBranchPlant"
                [maxlength]="50"
                format="#"
                id="{{ dataItem.changeItemId + '_compBranchPlant' }}"
                (valueChange)="
                  onPartValueChange(dataItem, 'compBranchPlant', $event)
                "
                [(ngModel)]="dataItem.compBranchPlant"
                [ngClass]="{
                  backgroundChange: dataItem.acdAction === 'Add'
                }"
              >
                >
              </kendo-textbox>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            field="operationSequence"
            title="Operation Sequence"
            [width]="200"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              @if(dataItem.acdAction == 'Delete') {

              <span [ngClass]="{ 'strike-text': dataItem.acdAction == 'Delete' }">
                {{ dataItem.operationSequence }}
              </span>
              }
              @else if( dataItem.operationSequence == 0 && (dataItem.acdAction=='No
              Change' || dataItem.acdAction == 'No change')) {
              <span>{{ dataItem.operationSequence }}</span>
              }
              @else {

              <kendo-numerictextbox
                [disabled]="otherUser"
                                    [spinners]="false"
                                    [value]="dataItem.operationSequence"
                                    [autoCorrect]="true"
                                    [step]="1"
                                    [maxlength]="50"
                                    [format]="customFormat(dataItem.operationSequence)"
                                    (valueChange)="
                  onPartValueChange(dataItem, 'operationSequence', $event)
                "
                                    format="#"
                                    id="{{ dataItem.changeItemId + '_operationSequence' }}"
                                    [(ngModel)]="dataItem.operationSequence"
                                    [ngClass]="{
                  backgroundChange:
                    dataItem.acdAction === 'Add' ||
                    dataItem.fieldChangedList?.includes('operationSequence'),
                  'field-mandatory':
                    dataItem.errorList?.includes('operationSequence')
                }"
              >
              </kendo-numerictextbox>
              }
            </ng-template>
          </kendo-grid-column>
          <ng-template kendoGridNoRecordsTemplate>
            <div class="norecordsmwobuild">No items to show...</div>
          </ng-template>
        </kendo-grid>
      </div>
      <span class="totalCount"
        >{{ filterPartsViewData.length }} Part<span
          *ngIf="filterPartsViewData.length > 1"
          >s</span
        ></span
      >
    </kendo-expansionpanel>
  </div>
</div>
<div class="bottomButtons">
  <button class="button-back" (click)="backBTNClicked()">
    <a class="backLink">Back</a>
  </button>
  <button
    [disabled]="otherUser"
    [ngStyle]="{'background-color': otherUser ? '#acadaf' : '', 'cursor': otherUser ? 'not-allowed' : '', }"
    class="button-primary btn2"
    (click)="validateJPBuild()"
  >
    Save and Add to CR
  </button>
</div>

<kendo-popup *ngIf="showJobplanPopup">
  <div class="popupDialog">
    <div class="popupHeader">
      <span class="popupTitle" id="popupTitle"
        >Find and replace job plan number</span
      >
      <fa-icon
        [icon]="iconPacks.FACLOSE"
        (click)="closePopup()"
        class="popupCLoseIcon"
      ></fa-icon>
    </div>
    <div class="popupContent">
      <form #frmJobPlan="ngForm">
        <div class="popUPReplace">
          <div class="form-group">
            <kendo-label
              for="oldJobPlanNumber"
              class="jobPlanText"
              text="Replace"
            >
            </kendo-label>
            <kendo-textbox
              #oldJobPlanNumber="ngModel"
              [(ngModel)]="changePlan.oldJobPlanNumber"
              [ngModelOptions]="{ standalone: true }"
              placeholder="Job plan number to be found"
              class="jobplanInput"
              required
            ></kendo-textbox>
            <p
              class="error"
              *ngIf="applyBtnPressed && changePlan.oldJobPlanNumber.length == 0"
            >
              <span *ngIf="oldJobPlanNumber?.errors?.['required'] "
                >Required field!</span
              >
            </p>
          </div>
          <div class="form-group">
            <kendo-label for="newJobPlanNumber" class="jobPlanText" text="With">
            </kendo-label>
            <kendo-textbox
              #newJobPlanNumber="ngModel"
              [(ngModel)]="changePlan.newJobPlanNumber"
              [ngModelOptions]="{ standalone: true }"
              class="jobplanInput"
              placeholder="New job plan number to replace"
              required
            ></kendo-textbox>
            <p
              class="error"
              *ngIf="changePlan.newJobPlanNumber.length == 0 && applyBtnPressed"
            >
              <span *ngIf="newJobPlanNumber?.errors?.['required'] "
                >Required field!</span
              >
            </p>
          </div>
          <button class="ApplyBtn" (click)="findJobPlan()">Apply</button>
        </div>
      </form>
    </div>
  </div>
</kendo-popup>

<app-content-popup
  *ngIf="popupShow && false"
  [dialogTitle]="popupTitle"
  [width]="popupWidth"
  [height]="popupHeight"
  (closeContentPopUp)="closeActionPopup($event)"
>
  <ng-container>
    <!-- <app-select-item-popup [setColumnConfig]="serviceTypeSelectColumn" [setPlaceholder]="searchPlaceHolder"
            [setGridData]="serviceTypeList" [setButtonName]="popupBtnText"
            (sendDataItem)="dataItemSelcted($event)"></app-select-item-popup> -->
  </ng-container>
</app-content-popup>

<!--  -->
<app-content-popup
  *ngIf="showFileUploadPopup"
  [dialogTitle]="popupTitle"
  [width]="popupWidth"
  [height]="popupHeight"
  (closeContentPopUp)="closeFileUploadPopup()"
>
  <ng-container>
    <app-build-import
      [setFieldValidationInput]="fieldValidationInput"
      (contentValidated)="imported($event)"
    ></app-build-import>
  </ng-container>
</app-content-popup>

<app-content-popup
  *ngIf="popupShow"
  [dialogTitle]="popupTitle"
  [width]="popupWidth"
  [height]="popupHeight"
  (closeContentPopUp)="closeActionPopup($event)"
>
  <ng-container>
    <app-select-item-popup
      [setColumnConfig]="popupGridColumn"
      [setPlaceholder]="searchPlaceHolder"
      [setGridData]="popupDataList"
      (sendDataItem)="dataItemSelcted($event)"
      (pageChanged)="popupPageChanged($event)"
    ></app-select-item-popup>
  </ng-container>
</app-content-popup>

<app-content-popup
  *ngIf="popupTccShow"
  [dialogTitle]="popupTitle"
  [width]="tccpopupWidth"
  [height]="tccpopupHeight"
  (closeContentPopUp)="closeActionPopup($event)"
>
  <ng-container>
    <app-select-tcc-popup
      [setColumnConfig]="popupGridColumn"
      [setPlaceholder]="searchPlaceHolder"
      [setGridData]="popupDataList"
      (sendDataItem)="dataItemSelcted($event)"
      (pageChanged)="popupPageChanged($event)"
    ></app-select-tcc-popup>
  </ng-container>
</app-content-popup>
